import { render, staticRenderFns } from "./plliang.vue?vue&type=template&id=83413742&"
import script from "./plliang.vue?vue&type=script&lang=js&"
export * from "./plliang.vue?vue&type=script&lang=js&"
import style0 from "./plliang.vue?vue&type=style&index=0&id=83413742&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports